import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import {WarriorClass} from "@/store/level/types";
import TextUtils from "@/utils/text-utils";
import {StringUtils} from "@/utils/string-utils";
import {Tr} from "@/i18n/i18n";
import {CreatureUtils} from "@/utils/creature-utils";
import PlayerStore from "@/store/player";
import {ForceDescription} from "@/store/player/types";
import {SquareButton} from "@/scenes.ui/square-button";
import OnceCaller from "@/utils/once-caller";

export class ListForceRanksPanel extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, wc: WarriorClass, fd: ForceDescription, rankLimit?: number) {
        super(scene);

        this.scene = scene;
        let stepY = 195;
        let y = 60;
        this.height = fd.descriptions.length * stepY + y + 30;

        let x = -250;

        const back0 = SpriteUtils.addImage(this.scene, x-100,y , Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK, 1.3, stepY/180).setOrigin(0, 0.5);
        const separator0 = SpriteUtils.addSprite(this.scene!, x-100, y+80, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 1.1, 1).setOrigin(0, 1);

        const image = SpriteUtils.addImage(this.scene, x+15, y-10, CreatureUtils.getForceAtlasLarge(wc),
            CreatureUtils.getLargeForceIcon(wc, true),  0.7, 0.7).setOrigin(0.5, 0.5);

        const imageLiner = SpriteUtils.addImage(this.scene, x+15, y, Keys.ATLAS_UI, Keys.UI_BADGE_LINER);

        let forceName = StringUtils.capitalizeFirstLetter(Tr('force').toLowerCase()) + ' ' + StringUtils.capitalizeFirstLetter(CreatureUtils.getClassNameGenetive(wc).toLowerCase())
        let text =  TextUtils.addTextAdvanced(scene, forceName, x + 80, y - 30,
            '#eec761', 20, 'normal', 480, 'left', 2, Fonts.BENGALY_NORMAL);

        let desc =  TextUtils.addTextAdvanced(scene, fd.shortDescription, x + 80, y -12,
            '#cbc1b2', 14, 'normal', 340, 'left', 2, Fonts.MYRIADPRO_REGULAR);
        desc.setOrigin(0, 0);

        this.add([back0, separator0, imageLiner, image, text, desc]);

        y+= 180;
        let rank = 1;
        fd.descriptions.forEach((desc, index) => {
            if(rankLimit && index >= rankLimit) return;
            const back = SpriteUtils.addImage(this.scene, x-100,y-102 , Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK, 1.3, 350/180).setOrigin(0, 0);
            const blueFade = SpriteUtils.addSprite(this.scene!, x -100 , y+stepY/2 + 11  + (index == 0? -2: 0),
                Keys.UI_MANUAL_BLUE_FADE, undefined, CU.CANVAS_WIDTH/CU.S / 22 * 1.1, stepY/180).setOrigin(0, 1);
            blueFade.alpha = 0.3;
            const topframe = SpriteUtils.addSprite(this.scene!, x -45 + CU.CANVAS_WIDTH/CU.S/2, y-stepY/2-6 + (index == 0? -2: 0),
                Keys.UI_MANUAL_TOP_FRAME, undefined, 1, 0.9).setOrigin(0.5, 0);

            let text =  TextUtils.addTextAdvanced(scene, Tr('rang') + " " + rank, x + CU.CANVAS_WIDTH/CU.S/2-45, y-97 + (index == 0? -2: 0),
                '#be8f46', 16, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            text.setOrigin(0.5,0);

            let descriptions:Phaser.GameObjects.Text[] = [];
            let dots:Phaser.GameObjects.Image[] = [];
            this.prepareDescription(desc).forEach((desc, index) => {
                let height = descriptions.reduce((acc, d) => acc + d.height/CU.S, 0);
                let forceDesc = TextUtils.addTextAdvanced(scene, desc, x + 20 + 14 -30, y + 40 - 90 + height + index * 13,
                    '#a9a8a1', 15, 'normal', 480, 'left', 2, Fonts.MYRIADPRO_REGULAR);
                forceDesc.setOrigin(0, 0);
                let goldDot = SpriteUtils.addSprite(this.scene, x + 20  -30, y + 40 - 90 + height + index * 13 + 12,
                    Keys.UI_GOLD_DOT, undefined, 1, 1);
                dots.push(goldDot);
                descriptions.push(forceDesc);
            })

            let descHeight = descriptions.reduce((acc, d) => acc + d.height/CU.S, 0) + (descriptions.length-1) * 13;

            const separator = SpriteUtils.addSprite(this.scene!, x-20 , y-stepY/2 + descHeight + 75,
                Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.95, 1).setOrigin(0, 1);
            separator.alpha = index == fd.descriptions.length - 1? 0 : 0.7;

            this.add([back, blueFade, separator, topframe, text, ...descriptions, ...dots]);// descText]);
            // y += stepY;
            y += descHeight + 75;
            rank++;
        });

        this.height = y - 60;
    }

    private prepareDescription(descText: string): string[] {
        let versions = descText.split('[long]');
        descText = versions.length > 1? versions[1].trim() : versions[0].trim();

        descText = descText.replace('[g]', '[color=#e0a141]');
        descText = descText.replace('[r]', '[color=#6e3c3c]');
        descText = descText.replace('[v]', '[color=#71d565]');
        descText = descText.replace('[/g]', '[/color]');
        descText = descText.replace('[/r]', '[/color]');
        descText = descText.replace('[/v]', '[/color]');

        let dot = '•';
        descText = descText.trim()
        descText = descText.toLowerCase()
        let parts = descText.split('\n');
        descText = parts.map(part => StringUtils.capitalizeFirstLetter(part.trim())).join("\n" + dot + " ")
        descText =  dot + " " + descText;
        // return descText;
        return descText.split('•').slice(1, descText.split('•').length);
    }

}
